import adjustColor from '@hellodarwin/core/web/features/helpers/adjust-color';
import { media } from '@hellodarwin/core/web/theme/mixins/responsive';
import styled, { css } from 'styled-components';
import { ContainerStyled } from '../../common/Container/styles';
import IconContainer from '../../common/IconContainer';
const carouselBannerThemes = {
    purple_5: {
        backgroundColor: (theme) => theme.colors.purple_4,
        imageColor: (theme) => theme.colors.purple_4,
        borderColor: (theme) => theme.colors.purple_2,
        svgColor: (theme) => theme.colors.purple_3,
    },
    green_4: {
        backgroundColor: (theme) => theme.colors.green_4,
        imageColor: (theme) => theme.colors.blue_4,
        borderColor: (theme) => theme.colors.green_1,
        svgColor: (theme) => theme.colors.green_2,
    },
    blue_4: {
        backgroundColor: (theme) => theme.colors.blue_4,
        imageColor: (theme) => theme.colors.orange_4,
        borderColor: (theme) => theme.colors.blue_1,
        svgColor: (theme) => theme.colors.blue_2,
    },
    yellow_4: {
        backgroundColor: (theme) => theme.colors.yellow_3,
        imageColor: (theme) => theme.colors.orange_4,
        borderColor: (theme) => theme.colors.yellow_1,
        svgColor: (theme) => theme.colors.yellow_2,
    },
    beige_4: {
        backgroundColor: (theme) => theme.colors.beige_4,
        imageColor: (theme) => theme.colors.purple_2,
        borderColor: (theme) => theme.colors.beige_1,
        svgColor: (theme) => theme.colors.beige_2,
    },
};
const getValidBackground = (bg) => {
    return ['yellow_4', 'purple_5', 'green_4', 'beige_4'].includes(bg !== null && bg !== void 0 ? bg : '')
        ? bg
        : 'beige_4';
};
export const ImageWrapper = styled.div `
  flex: 1;

  height: 550px;
  width: 100%;
  max-width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
  }
  ${media.l `
    flex:auto;  
    height:450px;
    `}
  ${media.md `
    height:auto;
    max-width:100%;
    img{
    height:auto !important;
    width:100% !important;
    aspect-ratio:16/9;
    }
    
    `}
`;
export const CarouselBannerContainer = styled(IconContainer) `
  min-height: 700px;

  ${media.md `
    align-items: flex-start;
    flex-direction: column-reverse;
  `}
  ${media.tablet `
      max-width:100%;
    `}
`;
export const CarouselBannerDetails = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl}px;
  width: 100%;
`;
export const CarouselBannerItems = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl}px;
  width: 100%;
`;
export const ItemContent = styled.div ``;
export const ItemHeader = styled.div `
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;
export const ItemBody = styled.div ``;
const ItemDefaultStyle = css `
  border-color: ${({ theme }) => theme.colors.grey_2};
  color: ${({ theme }) => theme.colors.grey_2};

  svg path {
    stroke: ${({ theme }) => theme.colors.grey_2};
  }

  &:hover {
    cursor: pointer;
    border-color: ${({ theme }) => theme.colors.purple_1};
    color: ${({ theme }) => theme.colors.purple_1};
    svg path {
      stroke: ${({ theme }) => theme.colors.purple_1};
    }
  }
`;
const ItemActiveStyle = css `
  border-color: ${({ theme }) => theme.colors.purple_2};
  color: ${({ theme }) => theme.colors.purple_2};
  transition: height 500ms;
  ${ItemHeader} {
    padding-bottom: 4px;
  }
  svg path {
    stroke: ${({ theme }) => theme.colors.purple_2};
  }
`;
export const ItemWrapper = styled.div `
  padding: 6px 24px;
  border-left: 2px solid ${({ theme }) => theme.colors.grey_2};
  ${({ $isActive }) => ($isActive ? ItemActiveStyle : ItemDefaultStyle)}
  .ReactCollapse--collapse {
    transition: height 500ms;
  }
`;
export const CarouselWrapper = styled.div `
  ${ContainerStyled} {
    ${({ theme, $variant }) => {
    const validVariant = getValidBackground($variant);
    const colors = carouselBannerThemes[validVariant];
    return css `
        border-top: 1px solid ${theme.colors.grey_4};

        background: radial-gradient(
          circle,
          ${adjustColor(colors.backgroundColor(theme), 20)} 0%,
          ${adjustColor(colors.backgroundColor(theme), 0)} 40%,
          ${adjustColor(colors.backgroundColor(theme), -20)} 100%
        );
        svg {
          color: ${colors.svgColor(theme)} !important;
        }
      `;
}}
  }
`;
export const CarouselBannerContent = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
